import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import axios from 'assets/js/axios'

export default function useList(route, keyValue, keyName = 'id') {
  const token = useSelector(state => state.Login.token)
  // eslint-disable-next-line
  const fetch = useCallback(() => {
    const headers = {
      Authorization: `Bearer ${token}`
    }

    return axios
      .get(route, { headers, params: { [keyName]: keyValue } })
      .then(response => response.data)
  }, [keyName, keyValue, route, token])

  return fetch
}
